export default __webpack_public_path__ + "static/media/mascot-adrift.1e2968d6.gif";